import React, { useState, useRef, useEffect } from 'react';
import {useHistory} from "react-router-dom";
import { useTranslation } from "react-i18next";
import {styled, useTheme} from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, {tableCellClasses} from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import NumberFormat from 'react-number-format';
import L from 'leaflet';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet'
import {isDesktop} from 'react-device-detect';
import ShopConfirm from "../ShopConfirm";
import {httpClient} from "../../core/HttpClient";
import 'leaflet/dist/leaflet.css';
import './style.css'
import FormControl from "@mui/material/FormControl";
import Alert from "@mui/material/Alert";
import {NativeSelect} from "@mui/material";
import Terms from "../Terms";
import Snackbar from "@mui/material/Snackbar";
import jwt_decode from "jwt-decode";
import IconButton from "@mui/material/IconButton";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import {TransitionProps} from "@mui/material/transitions";
import Slide from "@mui/material/Slide";
import Countdown from 'react-countdown';
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";


const interactionOptions = {
    zoomControl: isDesktop,
    doubleClickZoom: false,
    closePopupOnClick: true,
    dragging: true,
    zoomSnap: true,
    zoomDelta: true,
    trackResize: true,
    touchZoom: true,
    scrollWheelZoom: false,
};

const BootstrapInput = styled(InputBase)(({ theme }) => ({
    'label + &': {
        marginTop: theme.spacing(3),
    },
    '& .MuiInputBase-input': {
        borderRadius: 4,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderRadius: 4,
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
}));

const blueIcon = new L.Icon({
        iconUrl: `${process.env.REACT_APP_CDN_BASE_URL}/public/assets/pin-blue.png`,
        iconSize: [21, 34],
        iconAnchor: [10, 34]
    }),
    redIcon = new L.Icon({
        iconUrl: `${process.env.REACT_APP_CDN_BASE_URL}/public/assets/pin-red.png`,
        iconSize: [21, 34],
        iconAnchor: [10, 34]
    });

const LocationMarker = (props) => {
    const markerRef = useRef(null);
    const [icon, setIcon] = useState(props.ood?blueIcon:redIcon);

    const map = useMapEvents({
        move() {
            const marker = markerRef.current;
            if (marker != null) {
                marker.setLatLng(map.getCenter());
            }
        },
        moveend(e) {
            const marker = markerRef.current;
            if (marker != null) {
                let center = map.getCenter();
                let zoom = map.getZoom();
                setIcon(redIcon);
                if(props.callback){
                    props.callback(center.lat, center.lng, zoom);
                }
            }
        }
    });

    return props.initial === null ? null : (
        <>
            <Marker icon={icon} draggable={false} position={props.position} ref={markerRef} ></Marker>
        </>
    )
};

const PhoneFormatCustom = React.forwardRef((props, ref) =>
    <NumberFormat
        {...props}
        getInputRef={ref}
        type="tel"
        format="###-###-####"
    />);

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const OTPFormatCustom = React.forwardRef((props, ref) =>
    <NumberFormat
        {...props}
        getInputRef={ref}
        type="tel"
        format="######"
    />);

function selectAccountHandle(data){
    console.log('selectAccountHandle', data);
    if(data){

        if(data.selectedAccount){
            window.location.href = '/home';
        } else {
            localStorage.removeItem('token');
            localStorage.removeItem('refreshToken');
            window.location.href = '/login';
        }
    } else {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        window.location.href = '/login';
    }
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.grey["300"],
        color: theme.palette.common.black,
        fontWeight: 'bold',
        padding: 8
    },
}));

const DATES = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31];
const MONTHS = [1,2,3,4,5,6,7,8,9,10,11,12];
const YEARS = [];

let currentYear = new Date().getFullYear() + 543;
currentYear -= 18;
for(let i = currentYear; i>currentYear-118;i--){
    YEARS.push(i);
}

export default function Initial(props) {

    const { t } = useTranslation();
    const history = useHistory();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('sm'));
    const clockRef = useRef();
    const tick = useRef();
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState({step:-1, acceptAgreement: false});
    const [temp, setTemp] = useState({name: '', phone: '', address: '', type: 'STORE'});
    const [position, setPosition] = useState([13.721163782, 100.523664572]); // Default Bangkok
    const [map, setMap] = useState(null);
    const [showMap, setShowMap] = useState(false);
    const [openAgreement, setOpenAgreement] = useState(false);
    const [openOTPDialog, setOpenOTPDialog] = useState(false);
    const [requestOTP, setRequestOTP] = useState({referenceCode: '', otpId: '', otcId: '', otp: ''});
    const [otpFail, setOtpFail] = useState(0);
    const [counter, setCounter] = useState(0);
    const [mapGeoLocationError, setMapGeoLocationError] = useState(false);
    const [errors, setErrors] = useState([]);
    const [profile, setProfile] = useState({displayName: '', firstName: '', lastName: '', birthday: '', mobile: '', mobileVerified: ''});
    const [birthday, setBirthday] = useState({day: '', month: '', year: ''});
    const [acceptPrice, setAcceptPrice] = useState(false);

    useEffect(() => {
        console.log('[Initial]');
        const url = process.env.REACT_APP_API_BASE_URL + '/users/me';
            httpClient.get(url)
            .then(res => {
                let data = res.data;
                if(data){

                    if (!data.acceptAgreement) {
                        setOpenAgreement(true);
                    }

                    if(data.accounts && data.accounts[0]) {
                        if(data.firstName && data.firstName.length > 0 && data.lastName && data.lastName.length > 0){
                            let token = localStorage.getItem('token');
                            let decoded = jwt_decode(token);
                            if(decoded.account){
                                const url = process.env.REACT_APP_API_BASE_URL + '/users/account/selected';
                                httpClient.get(url)
                                    .then(res => {
                                        selectAccountHandle(res.data);
                                    });
                            } else {
                                history.push('/refresh');
                            }
                        } else {
                            // create profile
                            setState({step: 4, acceptAgreement: true});
                        }

                    } else if(!data.temp) {
                        // create new store
                        setState({step: 0, acceptAgreement: true});
                    } else if(data.temp) {
                        console.log('data.temp.coordinates', data.temp.coordinates);
                        setTemp(data.temp);

                        if(data.birthday){
                            // Setup Profile
                            let _profile = {displayName: data.displayName || ''
                                , firstName: data.firstName || ''
                                , lastName: data.lastName || ''
                                , birthday: data.birthday || ''
                                , mobile: data.mobile || ''
                                , mobileVerified: data.mobileVerified || ''
                            };

                            setProfile(_profile);
                            if(data.birthday.length === 8){
                                let day = parseInt(data.birthday.substring(0,2));
                                let month = parseInt(data.birthday.substring(2,4));
                                let year = parseInt(data.birthday.substring(4,8));
                                setBirthday({day: day, month: month, year: year});
                            }

                            // setup coordinates
                            if(!data.temp.coordinates){
                                // get client location
                                try{
                                    let processTimer = 0;
                                    let processTimout = false;
                                    tick.current = setInterval(() => {
                                        processTimer++;
                                        if(processTimer === 9){
                                            console.log('process timout');
                                            processTimout = true;
                                            setShowMap(true);
                                            setMapGeoLocationError(true);
                                            clearInterval(tick.current);
                                        }
                                        if(processTimer === 1){
                                            navigator.geolocation.getCurrentPosition(result=>{
                                                const coordinates = result.coords;
                                                if(!processTimout){
                                                    setTemp({...data.temp, zoom: 15, coordinates: {lat: coordinates.latitude, lng: coordinates.longitude}});
                                                    setPosition([coordinates.latitude, coordinates.longitude]);
                                                    setShowMap(true);
                                                }
                                                clearInterval(tick.current);
                                            }, function(positionError) {
                                                if(!processTimout){
                                                    setShowMap(true);
                                                    setMapGeoLocationError(true);
                                                }
                                                clearInterval(tick.current);
                                            }, {enableHighAccuracy: true, maximumAge: 10000, timeout: 8000});
                                        }

                                    }, 1000);

                                } catch(err){
                                    console.log(err);
                                    setShowMap(true);
                                    // done
                                }

                                setState({step: 1, acceptAgreement: true});
                            } else {
                                setState({step: 2, acceptAgreement: true});
                            }

                        } else if(data.temp.plan){
                            console.log('plan');
                            // Setup Plan
                            setState({step: 2, acceptAgreement: true});
                        } else if(data.temp.coordinates){
                            console.log('coordinates');
                            // select plan
                            setState({step: 2, acceptAgreement: true});
                        } else {
                            setState({step: 0, acceptAgreement: true});
                        }
                    } else {
                        localStorage.removeItem('token');
                        localStorage.removeItem('refreshToken');
                        history.push('/login');
                    }
                } else {
                    localStorage.removeItem('token');
                    localStorage.removeItem('refreshToken');
                    history.push('/login');
                }
            });
    }, [history]);

    const handleProfileChange = ({ target }) => {
        setProfile({...profile, [target.name]: target.value});
    };

    const handleTempChange = ({ target }) => {
        setTemp({...temp, [target.name]: target.value});
    };

    const handleMapChange = (lat, lng, zoom) => {
        if(map){
            setTemp({...temp,zoom: zoom, coordinates: {lat: lat, lng: lng}});
        }
    };

    const handleBirthdayChange = ({ target }) => {
        setBirthday({...birthday, [target.name]: target.value});
    };

    const handleAcceptPriceCheck = () => {
        setTemp({...temp, plan: 'STANDARD'});
        let ap = !acceptPrice;
        setAcceptPrice(ap);
    };

    const handlePrevious = (previous) => {
        setState({step: previous, acceptAgreement: true});
        if(temp && temp.coordinates && map){
            setMap({lat: temp.coordinates[0], lng: temp.coordinates[1]});
        }
        setShowMap(true);
    };

    const handleAcceptAgreement = () => {
        const url = process.env.REACT_APP_API_BASE_URL + '/users/me/accept';
        setLoading(true);
        httpClient.post(url, {})
            .then(res => {
                setLoading(false);
                setOpenAgreement(false);
            });
    };

    const handleRequestOTP = () =>{
        if(counter <= 0){
            callRequestOTP();
            setOtpFail(0);
            setCounter(900); // 15 minutes
            // tick.current.start(); // not working
        }
    };

    const handleCloseOTPDialog = () => {
        setOpenOTPDialog(false);
    };

    const handleOTPStart = () => {
        console.log('handleOTPStart');
    };

    const handleOTPTick = () => {
        let c = counter;
        setCounter(--c);
        if(c===0){
            clockRef.current.stop();
            setRequestOTP({referenceCode: '', otpId: '', otcId: '', otp: ''});
            setOpenOTPDialog(false);
        }
    };

    const handleConfirmOTP = () => {
        const url = process.env.REACT_APP_API_BASE_URL + '/users/me/confirm/otp';
        setLoading(true);
        httpClient.post(url, {...requestOTP, mobile: profile.mobile})
            .then(res => {
                if(res.data){
                    if(res.data.status === 202){
                        setOtpFail(2);
                    }else{
                        setRequestOTP({referenceCode: '', otpId: '', otcId: '', otp: ''});
                        setOpenOTPDialog(false);
                        _confirmNextStep(1);
                    }
                }
                setLoading(false);
            }).catch(e=>{
            setOtpFail(2);
            setLoading(false);
        });
    };

    const callRequestOTP = () => {
        const url = process.env.REACT_APP_API_BASE_URL + '/users/me/request/otp';
        setLoading(true);
        httpClient.post(url, {mobile: profile.mobile})
            .then(res => {
                if(res.data){
                    if(res.data.status === 202){

                    }else{
                        setRequestOTP({
                            referenceCode: res.data.referenceCode,
                            otpId: res.data.otpId,
                            otcId: res.data.otcId,
                            otp: ''
                        });
                    }

                }
                setLoading(false);
            }).catch(e=>{
            setLoading(false);
        });
    };

    const handleOTPChange = ({ target }) => {
        setRequestOTP({ ...requestOTP, [target.name]: target.value });
    };

    const handleSaveTemp = (next) => {
        if(_validation()){
            if(profile.mobile === profile.mobileVerified){

                _confirmNextStep(next);

            } else {
                setOpenOTPDialog(true);
            }
        }

    };

    const handleConfirm = (newUser) => {
        handleSubmit();
    };

    const handleSubmit = () => {
        if(temp.coordinates){
            const url = process.env.REACT_APP_API_BASE_URL + '/accounts/me/temp';
            httpClient.post(url, temp).then(res => {
                if(res.status !== 200) {
                    return Promise.reject(res);
                }

                const url = process.env.REACT_APP_API_BASE_URL + '/users/account/selected';
                return httpClient.get(url);
            }).then(res => {
                selectAccountHandle(res.data);
            });
        } else {
            const url = process.env.REACT_APP_API_BASE_URL + '/users/account/selected';
            httpClient.get(url).then(res=>{
                selectAccountHandle(res.data);
            });
        }
    };

    function _confirmNextStep(next){
        setErrors([]);
        const url = process.env.REACT_APP_API_BASE_URL + '/users/me/temp';
        setLoading(true);
        httpClient.post(url, temp)
            .then(res => {
                if(next===1){
                    const url = process.env.REACT_APP_API_BASE_URL + '/users/profile';
                    let d = ("0" + birthday.day).slice(-2);
                    let m = ("0" + birthday.month).slice(-2);
                    let y = birthday.year;
                    let bd = d+m+y;
                    setProfile({...profile, birthday: d+m+y, mobileVerified: profile.mobile});
                    httpClient.put(url, {firstName: profile.firstName, lastName: profile.lastName, mobile: profile.mobile, birthday: bd})
                        .then(res => {
                            if(!temp.coordinates){
                                // get client location
                                try{
                                    let processTimer = 0;
                                    let processTimout = false;
                                    tick.current = setInterval(() => {
                                        if(processTimer === 9){
                                            console.log('process timout');
                                            processTimout = true;
                                            setShowMap(true);
                                            setLoading(false);
                                            setMapGeoLocationError(true);
                                            clearInterval(tick.current);
                                        }
                                        navigator.geolocation.getCurrentPosition(result=>{
                                            if(!processTimout){
                                                const coordinates = result.coords;
                                                setTemp({...temp, zoom: 15, coordinates: {lat: coordinates.latitude, lng: coordinates.longitude}});
                                                setPosition([coordinates.latitude, coordinates.longitude]);
                                                setShowMap(true);
                                                setLoading(false);
                                            }
                                            clearInterval(tick.current);
                                        }, function(positionError) {
                                            if(!processTimout){
                                                setShowMap(true);
                                                setMapGeoLocationError(true);
                                                setLoading(false);
                                            }
                                            clearInterval(tick.current);
                                        }, {enableHighAccuracy: true, maximumAge: 10000, timeout: 8000});
                                    }, 1000);
                                } catch(err){
                                    console.log(err);
                                    setShowMap(true);
                                    setLoading(false);
                                    // done
                                }
                            } else {
                                setShowMap(true);
                                setLoading(false);
                                setState({step: next, acceptAgreement: true});
                            }
                        });

                }

                if(next === 4){
                    let newUser = res.data.newUser;
                    handleConfirm(newUser);
                } else {
                    setLoading(false);
                    setState({step: next, acceptAgreement: true});
                }
            });
    }

    function _validation() {
        let _errors = [];
        if(!temp.name || temp.name.length === 0){
            _errors.push('name');
        }
        if(!temp.address || temp.address.length === 0){
            _errors.push('address');
        }

        // let _phone = null;
        // if(temp.phone){
        //     _phone = temp.phone.replace(/\D/g,'');
        // }
        // if(!_phone ||
        //     _phone.length !== 10 ||
        //     !_phone.startsWith('0')
        // ){
        //     _errors.push('phone');
        // }

        if(!profile.firstName ||
            profile.firstName.length === 0){
            _errors.push('firstName');
        }
        if(!profile.lastName ||
            profile.lastName.length === 0){
            _errors.push('lastName');
        }
        if(!profile.lastName ||
            profile.lastName.length === 0){
            _errors.push('lastName');
        }

        let _mobile = null;
        if(profile.mobile){
            _mobile = profile.mobile.replace(/\D/g,'');
        }
        if(!_mobile ||
            _mobile.length !== 10 ||
            !_mobile.startsWith('0')
        ){
            _errors.push('mobile');
        }

        if(birthday.day === ''
            || birthday.month === ''
            || birthday.year === ''){
            _errors.push('birthday');
        }

        setErrors(_errors);

        return _errors.length === 0;
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setMapGeoLocationError(false);
    };

    return (
        <div>
            {state.step === -1 &&
                <Box display="flex" justifyContent="center" mt={4}>
                    <CircularProgress size={20}/>
                </Box>
            }
            {state.step === 0 &&
                <Box p={2}>
                    <form noValidate autoComplete="off">
                        <Box>
                            <Typography variant="h6">
                                {t('shop.registration')}
                            </Typography>
                        </Box>
                        <Divider style={{'marginBottom': '10px', 'marginTop': '10px'}} />
                        <Box>
                            <Typography variant="body1">
                                {t('shop.information')}
                            </Typography>
                        </Box>
                        <Box mt={2}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <TextField id="account-name" label={t('shop.name')} variant="outlined" fullWidth={true}
                                               name="name" value={ temp.name } error={errors.indexOf('name') > -1} onChange={ handleTempChange } required />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField id="account-address" label={t('shop.address')} variant="outlined" fullWidth={true}
                                               name="address" value={ temp.address } error={errors.indexOf('address') > -1} multiline rows={2} onChange={ handleTempChange } required />
                                </Grid>
                                {/*<Grid item xs={12}>*/}
                                {/*    <TextField id="account-mobile"*/}
                                {/*               label={t('shop.mobile')}*/}
                                {/*               variant="outlined"*/}
                                {/*               fullWidth={true}*/}
                                {/*               name="phone" type="tel"*/}
                                {/*               value={temp.phone}*/}
                                {/*               error={errors.indexOf('phone') > -1}*/}
                                {/*               onChange={ handleTempChange }*/}
                                {/*               InputProps={{*/}
                                {/*                   inputComponent: PhoneFormatCustom,*/}
                                {/*               }}*/}
                                {/*               required />*/}
                                {/*</Grid>*/}
                            </Grid>
                            <Box mt={3}>
                                <Typography variant="body1">
                                    {t('shop.register')}
                                </Typography>
                            </Box>
                            <Box mt={2}>
                                <Box display="flex" justifyContent="center" alignItems="center">
                                    <TextField id="firstName" label={t('profile.firstName')} variant="outlined" fullWidth={true}
                                               name="firstName" value={ profile.firstName } onChange={ handleProfileChange } required />
                                </Box>
                            </Box>
                            <Box mt={2}>
                                <Box display="flex" justifyContent="center" alignItems="center">
                                    <TextField id="lastName" label={t('profile.lastName')} variant="outlined" fullWidth={true}
                                               name="lastName" value={ profile.lastName } onChange={ handleProfileChange } required />
                                </Box>
                            </Box>
                            <Box mt={2}>
                                <TextField id="outlined-basic"
                                           label={t('profile.mobile')}
                                           variant="outlined"
                                           fullWidth={true}
                                           name="mobile" type="tel"
                                           value={profile.mobile}
                                           error={errors.indexOf('mobile') > -1}
                                           onChange={ handleProfileChange }
                                           InputProps={{
                                               inputComponent: PhoneFormatCustom,
                                           }}
                                           required />
                            </Box>
                            <Box mt={3}>
                                <Box mb={1}>
                                    <Typography>
                                        {t('profile.birthday')}*
                                    </Typography>
                                </Box>
                                <Grid container spacing={2}>
                                    <Grid item xs={3}>
                                        <FormControl variant="outlined"
                                                     fullWidth={true}>
                                            <NativeSelect
                                                name="day"
                                                value={ birthday.day }
                                                onChange={ handleBirthdayChange }
                                                input={<BootstrapInput />}>
                                                {birthday.day === '' && <option value="">{t('common.duration.day')}</option>}
                                                {DATES.map((value, i) => {
                                                    return (<option value={value} key={`d-${i}`}>{value}</option>)
                                                })}
                                            </NativeSelect>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <FormControl variant="outlined"
                                                     fullWidth={true}>
                                            <NativeSelect
                                                name="month"
                                                value={ birthday.month }
                                                onChange={ handleBirthdayChange }
                                                input={<BootstrapInput />}>
                                                {birthday.month === '' && <option value="">{t('common.duration.month')}</option>}
                                                {MONTHS.map((value, i) => {
                                                    return (<option value={value} key={`m-${i}`}>{t(`common.months.${value}.name`)}</option>)
                                                })}
                                            </NativeSelect>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <FormControl variant="outlined"
                                                     fullWidth={true}>
                                            <NativeSelect
                                                name="year"
                                                value={ birthday.year }
                                                onChange={ handleBirthdayChange }
                                                input={<BootstrapInput />}>
                                                {birthday.year === '' && <option value="">{t('common.duration.year')}</option>}
                                                {YEARS.map((value, i) => {
                                                    return (<option value={value} key={`y-${i}`}>{value}</option>)
                                                })}
                                            </NativeSelect>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box mt={1}>
                                <Typography variant={"caption"}>
                                    *{t('initial.ageAgreement')}
                                </Typography>
                            </Box>
                        </Box>
                    </form>
                    <div style={{'marginTop': '20px'}}>
                        <Box display="flex" justifyContent="flex-end">
                            <Button variant="contained"
                                    color="primary"
                                    disableElevation
                                    size="large"
                                    fullWidth={matches}
                                    onClick={(e) => handleSaveTemp(1)}
                                    disabled={ temp.name.trim().length === 0
                                        || temp.address.trim().length === 0
                                        // || temp.phone.length === 0
                                        // || temp.phone.replace(/\D/g,'').length !== 10
                                        || profile.firstName.trim().length === 0
                                        || profile.lastName.trim().length === 0
                                        || profile.mobile.replace(/\D/g,'').length !== 10
                                        || birthday.day === ''
                                        || birthday.month === ''
                                        || birthday.year === ''
                                        || loading}>
                                {t('common.next')}
                            </Button>
                        </Box>
                    </div>
                </Box>
            }
            {state.step === 1 &&
                <Box p={2}>
                    <form noValidate autoComplete="off">
                        <Box>
                            <Typography variant="h6">
                                {t('shop.location')}
                            </Typography>
                        </Box>
                        <Divider style={{'marginBottom': '10px', 'marginTop': '10px'}} />
                        <Box mt={2} style={{height: `300px`}}>
                            {!showMap &&
                                <Box display="flex" justifyContent="center" mt={4}>
                                    <CircularProgress size={20}/>
                                </Box>
                            }
                            {showMap &&
                                <MapContainer center={temp.coordinates ? temp.coordinates : position}
                                              zoom={temp.zoom ? temp.zoom : 15}
                                              {...interactionOptions}
                                              ref={setMap}
                                              scrollWheelZoom={false}>
                                    <TileLayer
                                        attribution='&copy; <a href="http://osm.org/copyright" target="_blank">OpenStreetMap</a> contributors'
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                    />
                                    {position[0] &&
                                        <LocationMarker effectOn={this}
                                                        ood={temp.coordinates ? false : true}
                                                        position={temp.coordinates ? temp.coordinates : position}
                                                        callback={handleMapChange}/>
                                    }
                                </MapContainer>
                            }
                        </Box>
                        <Box mt={1}>
                            <Typography variant="caption">
                                {t('shop.locationMessage')}
                            </Typography>
                        </Box>
                    </form>
                    <div style={{'marginTop': '20px'}}>
                        <Box display="flex" justifyContent="space-between">
                            <Button variant="contained"
                                    disableElevation
                                    size="large"
                                    fullWidth={matches}
                                    color={"grey"}
                                    onClick={(e) => handlePrevious(0)}>
                                {t('common.previous')}
                            </Button>
                            <div>&nbsp;</div>
                            <Button variant="contained"
                                    color="primary"
                                    disableElevation
                                    size="large"
                                    fullWidth={matches}
                                    onClick={(e) => handleSaveTemp(2)}
                                    disabled={!temp.coordinates || loading}>
                                {t('common.next')}
                            </Button>
                        </Box>
                    </div>
                </Box>
            }
            {state.step === 2 &&
                <Box p={2}>
                    <form noValidate autoComplete="off">
                        <Box>
                            <Typography variant="h6">
                                {t('shop.confirm')}
                            </Typography>
                        </Box>
                        <Divider style={{'marginBottom': '10px', 'marginTop': '10px'}} />
                        <Box mt={2}>
                            <ShopConfirm temp={temp} profile={profile} />
                        </Box>
                    </form>
                    <Box mt={4}>
                        <div style={{'marginTop': '20px'}}>
                            <Box display="flex" justifyContent="space-between">
                                <Button variant="contained"
                                        disableElevation
                                        size="large"
                                        fullWidth={matches}
                                        color={"grey"}
                                        onClick={(e) => handlePrevious(1)}>
                                    {t('common.previous')}
                                </Button>
                                <div>&nbsp;</div>
                                <Button variant="contained"
                                        color="primary"
                                        disableElevation
                                        size="large"
                                        fullWidth={matches}
                                        onClick={(e) => handleSaveTemp(3)}
                                        disabled={!temp.coordinates || loading}>
                                    {t('common.next')}
                                </Button>
                            </Box>
                        </div>
                    </Box>
                </Box>
            }
            {state.step === 3 &&
                <Box p={2}>
                    <Box>
                        <Typography variant="h6">
                            {t('pricing.pricingRate')}
                        </Typography>
                    </Box>
                    <Divider style={{'marginBottom': '10px', 'marginTop': '10px'}} />
                    <TableContainer>
                        <Table id="pricing-table" aria-label="simple table" sx={{border: '1px solid gainsboro'}}>
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell
                                        align="center" style={{
                                        borderRight: '2px solid white',
                                        fontWeight: 'normal'
                                    }}>{t('pricing.commissionFee')}</StyledTableCell>
                                    <StyledTableCell
                                        align="center" style={{
                                        borderRight: '2px solid white',
                                        fontWeight: 'normal'
                                    }}>{t('pricing.income')}</StyledTableCell>
                                    <StyledTableCell align="center" style={{
                                        borderLeft: '2px solid white',
                                        fontWeight: 'normal'
                                    }}>{t('pricing.order')}</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {/*<TableRow>*/}
                                {/*    <TableCell style={{borderRight: '1px solid gainsboro'}}*/}
                                {/*               align="center">*/}
                                {/*        <Box>{t('pricing.rateFee.R0.fee')}</Box>*/}
                                {/*    </TableCell>*/}
                                {/*    <TableCell style={{borderRight: '1px solid gainsboro'}}*/}
                                {/*               align="center">*/}
                                {/*        <Box>{t('pricing.rateFee.R0.income')}</Box>*/}
                                {/*    </TableCell>*/}
                                {/*    <TableCell style={{borderRight: '1px solid gainsboro'}}*/}
                                {/*               align="center" >*/}
                                {/*        <Box>{t('pricing.rateFee.R0.order')}</Box>*/}
                                {/*    </TableCell>*/}
                                {/*</TableRow>*/}
                                <TableRow>
                                    <TableCell style={{borderRight: '1px solid gainsboro'}}
                                               align="center">
                                        <Box>{t('pricing.rateFee.R1.fee')}</Box>
                                    </TableCell>
                                    <TableCell style={{borderRight: '1px solid gainsboro'}}
                                               align="center">
                                        <Box>{t('pricing.rateFee.R1.income')}</Box>
                                    </TableCell>
                                    <TableCell style={{borderRight: '1px solid gainsboro'}}
                                               align="center" >
                                        <Box>{t('pricing.rateFee.R1.order')}</Box>
                                    </TableCell>
                                </TableRow>
                                {/*<TableRow>*/}
                                {/*    <TableCell style={{borderRight: '1px solid gainsboro'}}*/}
                                {/*               align="center">*/}
                                {/*        <Box>{t('pricing.rateFee.R2.fee')}</Box>*/}
                                {/*    </TableCell>*/}
                                {/*    <TableCell style={{borderRight: '1px solid gainsboro'}}*/}
                                {/*               align="center">*/}
                                {/*        <Box>{t('pricing.rateFee.R2.income')}</Box>*/}
                                {/*    </TableCell>*/}
                                {/*    <TableCell style={{borderRight: '1px solid gainsboro'}}*/}
                                {/*               align="center" >*/}
                                {/*        <Box>{t('pricing.rateFee.R2.order')}</Box>*/}
                                {/*    </TableCell>*/}
                                {/*</TableRow>*/}
                                {/*<TableRow>*/}
                                {/*    <TableCell style={{borderRight: '1px solid gainsboro'}}*/}
                                {/*               align="center">*/}
                                {/*        <Box>{t('pricing.rateFee.R3.fee')}</Box>*/}
                                {/*    </TableCell>*/}
                                {/*    <TableCell style={{borderRight: '1px solid gainsboro'}}*/}
                                {/*               align="center">*/}
                                {/*        <Box>{t('pricing.rateFee.R3.income')}</Box>*/}
                                {/*    </TableCell>*/}
                                {/*    <TableCell style={{borderRight: '1px solid gainsboro'}}*/}
                                {/*               align="center" >*/}
                                {/*        <Box>{t('pricing.rateFee.R3.order')}</Box>*/}
                                {/*    </TableCell>*/}
                                {/*</TableRow>*/}
                                {/*<TableRow>*/}
                                {/*    <TableCell style={{borderRight: '1px solid gainsboro'}}*/}
                                {/*               align="center">*/}
                                {/*        <Box>{t('pricing.rateFee.R4.fee')}</Box>*/}
                                {/*    </TableCell>*/}
                                {/*    <TableCell style={{borderRight: '1px solid gainsboro'}}*/}
                                {/*               align="center">*/}
                                {/*        <Box>{t('pricing.rateFee.R4.income')}</Box>*/}
                                {/*    </TableCell>*/}
                                {/*    <TableCell style={{borderRight: '1px solid gainsboro'}}*/}
                                {/*               align="center" >*/}
                                {/*        <Box>{t('pricing.rateFee.R4.order')}</Box>*/}
                                {/*    </TableCell>*/}
                                {/*</TableRow>*/}
                                {/*<TableRow>*/}
                                {/*    <TableCell style={{borderRight: '1px solid gainsboro'}}*/}
                                {/*               align="center">*/}
                                {/*        <Box>{t('pricing.rateFee.R5.fee')}</Box>*/}
                                {/*    </TableCell>*/}
                                {/*    <TableCell style={{borderRight: '1px solid gainsboro'}}*/}
                                {/*               align="center">*/}
                                {/*        <Box>{t('pricing.rateFee.R5.income')}</Box>*/}
                                {/*    </TableCell>*/}
                                {/*    <TableCell style={{borderRight: '1px solid gainsboro'}}*/}
                                {/*               align="center" >*/}
                                {/*        <Box>{t('pricing.rateFee.R5.order')}</Box>*/}
                                {/*    </TableCell>*/}
                                {/*</TableRow>*/}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box mt={2}>
                        <Box>
                            <Typography variant={"caption"}>
                                {t('pricing.remark')}
                            </Typography>
                        </Box>
                        <Box>
                            <Typography variant={"caption"}>
                                {t('pricing.remark1')}
                            </Typography>
                        </Box>
                        {/*<Box>*/}
                        {/*    <Typography variant={"caption"}>*/}
                        {/*        {t('pricing.remark2')}*/}
                        {/*    </Typography>*/}
                        {/*</Box>*/}
                        <Box>
                            <Typography variant={"caption"}>
                                {t('pricing.remark3')}
                            </Typography>
                        </Box>
                        <Box>
                            <Typography variant={"caption"}>
                                {t('pricing.remark4')}
                            </Typography>
                        </Box>
                    </Box>
                    <Box mt={2}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={acceptPrice}
                                    onChange={handleAcceptPriceCheck}
                                    name="acceptPrice"
                                    color="primary"
                                />
                            }
                            label={t('pricing.acceptPrice')}
                        />
                    </Box>
                    <div style={{'marginTop': '10px'}}>
                        <Box display="flex" justifyContent="space-between">
                            <Button variant="contained"
                                    disableElevation
                                    size="large"
                                    fullWidth={matches}
                                    color={"grey"}
                                    onClick={(e) => handlePrevious(2)}>
                                {t('common.previous')}
                            </Button>
                            <div>&nbsp;</div>
                            <Button variant="contained"
                                    color="primary"
                                    style={{ fontWeight: (temp.plan)?'bold':'normal' }}
                                    disableElevation
                                    size="large"
                                    fullWidth={matches}
                                    onClick={(e) => handleSaveTemp(4)}
                                    disabled={!acceptPrice || loading}>
                                {t('common.next')}
                            </Button>
                        </Box>
                    </div>
                </Box>
            }
            {state.step === 4 &&
                <Box p={2}>
                    <Box>
                        <Typography variant="h6">
                            {t('initial.payment')}
                        </Typography>
                    </Box>
                    <Divider style={{'marginBottom': '10px', 'marginTop': '10px'}} />
                    <div>

                    </div>
                </Box>
            }
            <Dialog
                open={openAgreement}
                scroll="paper"
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle id="scroll-dialog-title">{t('initial.agreement')}</DialogTitle>
                <DialogContent dividers={true}>
                    <DialogContentText
                        id="scroll-dialog-description"
                        component="div"
                        tabIndex={-1}
                    >
                        <Terms />
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button  variant="contained"
                             color="primary"
                             size="large"
                             disableElevation
                             fullWidth={true}
                             disabled={loading}
                             onClick={(e) => handleAcceptAgreement(e)}>
                        {t('initial.agree')}
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openOTPDialog}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleCloseOTPDialog}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>
                    <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                        <Typography variant={"h6"}>
                            {t('verification.mobileVerification')}
                        </Typography>
                        <IconButton edge={"end"} onClick={handleCloseOTPDialog}>
                            <CloseRoundedIcon />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent>
                    <Box>
                        {counter === 0 && <>
                            <Box mb={1}>
                                <Box>{t('verification.otpFormRequest')}</Box>
                                <Box>{t('verification.otpFormRequestMobile', {mobile: profile.mobile})}</Box>
                            </Box>
                            <Box>
                                <Button variant="outlined"
                                        color="primary"
                                        size="large"
                                        disableElevation
                                        fullWidth={true}
                                        onClick={handleRequestOTP}>
                                    {t('common.otpRequest')}
                                </Button>
                            </Box>
                        </>
                        }
                        {counter !== 0 &&
                        <>
                            <Box mb={1}>
                                <Box>{t('verification.otpFormSubmit')}</Box>
                                <Box>{t('verification.otpFormSubmitMobile', {mobile: profile.mobile})}</Box>
                            </Box>
                            <Box mb={2}>
                                <TextField id="otp"
                                           variant="outlined"
                                           fullWidth={true}
                                           name="otp" type="tel"
                                           value={requestOTP.otp}
                                           onChange={handleOTPChange}
                                           error={otpFail===2}
                                           helperText={otpFail===2?t('verification.otpInvalid'):''}
                                           InputProps={{
                                               inputComponent: OTPFormatCustom,
                                           }}
                                           required/>
                            </Box>
                            <Box mb={2}>
                                <Countdown
                                    ref={clockRef}
                                    date={Date.now() + 1000 * 900}
                                    autoStart={false}
                                    onStart={handleOTPStart}
                                    onTick={handleOTPTick}
                                    renderer={props => <span className="font-light italic">*{t('verification.otpTimeout')}</span>}
                                />
                            </Box>
                            <Box>
                                <Button  variant="contained"
                                         color="primary"
                                         size="large"
                                         disableElevation
                                         fullWidth={true}
                                         disabled={loading}
                                         onClick={handleConfirmOTP}
                                >
                                    {t('verification.confirm')}
                                </Button>
                            </Box>
                        </>
                        }
                    </Box>
                </DialogContent>
            </Dialog>
            <Snackbar open={mapGeoLocationError}
                      anchorOrigin={{vertical:'top', horizontal:'center'}}
                      autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="warning">
                    {t('common.message.geoLocationFail')}
                </Alert>
            </Snackbar>
        </div>
    )
}